module.exports = {"451027100":"泗城镇","451027101":"逻楼镇","451027102":"加尤镇","451027103":"下甲镇","451027201":"伶站瑶族乡","451027202":"朝里瑶族乡","451027203":"沙里瑶族乡","451027205":"玉洪瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451027.json
// module id = 2275
// module chunks = 0